var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.21 99.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.3,99.09H1.91c-.57,0-1.03-.46-1.03-1.03v-54.4c0-.57.46-1.03,1.03-1.03h48.73l3.71-6.65c.18-.32.52-.53.9-.53h42.05c.57,0,1.03.46,1.03,1.03v61.58c0,.27-.11.53-.3.73-.19.19-.45.3-.73.3ZM2.94,97.03h93.34s0-59.52,0-59.52h-40.42l-3.71,6.65c-.18.32-.52.53-.9.53H2.94v52.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.15,44.19c-.57,0-1.03-.46-1.03-1.03V8.89c0-.57.46-1.03,1.03-1.03h53.99c.27,0,.52.1.71.29l17.9,17.23c.2.19.31.46.31.74v9.66c0,.57-.46,1.03-1.03,1.03s-1.03-.46-1.03-1.03v-9.22l-17.29-16.64H7.17v33.25c0,.57-.46,1.03-1.03,1.03Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.03,27.15h-17.54c-.57,0-1.03-.46-1.03-1.03V9.54c0-.57.46-1.03,1.03-1.03s1.03.46,1.03,1.03v15.56h16.51c.57,0,1.03.46,1.03,1.03s-.46,1.03-1.03,1.03Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.55,36.55c-.57,0-1.03-.46-1.03-1.03V2.18H22.51v6.71c0,.57-.46,1.03-1.03,1.03s-1.03-.46-1.03-1.03V1.15c0-.57.46-1.03,1.03-1.03h72.07c.57,0,1.03.46,1.03,1.03v34.37c0,.57-.46,1.03-1.03,1.03Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.5ab8e3d52f0f1c05c5dd96295e0921f7.svg";
export { ForwardRef as ReactComponent };